<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    aria-hidden="true"
    data-slot="icon"
    class="spinner"
  >
    <path stroke-linecap="round" stroke-linejoin="round" d="M12 3c4.937 0 9 4.063 9 9" />
  </svg>
</template>

<style>
@reference "../css/tailwind.css";

.spinner {
  @apply animate-spin;
}
</style>
